import { assertArray, assertTrue, assertValue } from "../../../utils/assert";
import { Forest, Node, selfAndAncestors } from "../../../../utils/Forest";
import { Division } from "../../../../models";
import { Store } from "../../../../flux/Store";
import { names, SetTargetPayload } from "./CurrentDivisionActions";

export interface CurrentDivisionStoreState
{
    allDivisions: Division[];
    forest: Forest<Division>;
    path: Division[];

    selectedDivisionId: number;
}

const createForest = (divisions: Division[]) => new Forest(d => d.id, d => d.ParentId, divisions);

export class CurrentDivisionStore extends Store<CurrentDivisionStoreState>
{
    constructor()
    {
        super();
        this.state = { allDivisions: [], forest: null, path: [], selectedDivisionId: undefined };

        this.register<SetTargetPayload>(names.SET_TARGET_DIVISION, e => {
            const { targetDivisionId, allDivisions = this.state.allDivisions } = e.payload;

            const { forest: forestOld } = this.state;
            const forestNew = createForest(allDivisions);
            const path = calcPath(targetDivisionId, forestNew, forestOld);
            const selectedDivisionId = path.length > 0 ? path[path.length - 1].id : targetDivisionId;

            localStorage.setItem('selectedDivisionId', selectedDivisionId.toString());

            return this.field({
                allDivisions,
                forest: forestNew,
                path,
                selectedDivisionId: selectedDivisionId
            });
        });
    }

    getCurrentDivision = () => {
        const { path } = this.state;
        return path[path.length - 1];
    }

    getCurrentDivisionId = () => {
        return this.state.selectedDivisionId;
    }
}

// target division could be absent in the new version of the forest
function calcPath (targetId: number, forestNew: Forest<Division>, forestOld: Forest<Division>): Division[]
{
    let targetNew: Node<Division>;
    while(!targetNew && targetId != null) {
        targetNew = forestNew.getByKey(targetId);
        if(!targetNew) {
            let targetOld = forestOld.getByKey(targetId);
            targetId = (targetOld && targetOld.parent && targetOld.parent.value) ? targetOld.parent.value.id : null;
        }
    }

    if(targetNew) {
        return selfAndAncestors(targetNew).reverse();
    }
    
    const roots = forestNew.getRoots();
    return roots.length > 0 ? [roots[0].value] : [];        
}


// WEBPACK FOOTER //
// ./src/app/components/DivisionPath/flux/CurrentDivisionStore.ts